<template>
  <div>
    <div>
      <!-- 长图-->
      <div
        class="long van-hairline--bottom"
        v-if="item.type !== 3 && item.type !== 7 && item.display_type === 2"
        @click="linkItem(item)"
      >
        <span
          decode
          class="container-title van-multi-ellipsis--l2"
        >
          {{ item.title }}
        </span>
        <div class="long-img">
          <van-image
            width="100%"
            fit="cover"
            height="193px"
            radius="3"
            :src="item.pic"
          />
        </div>
        <div class="flex-center bottom">
          <div class="type">长图</div>
          <div class="flex-center">
            <img
              src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
              style="width:16px; height: 16px;margin-right: 2px;"
            />{{ item.readnum }}
          </div>
        </div>
      </div>
      <!-- 多图 -->
      <div
        class="more flex-center van-hairline--bottom"
        v-if="item.type !== 3 && item.type !== 7 && item.display_type === 1"
        @click="linkItem(item)"
      >
        <div class="left flex-center">
          <span
            decode
            class="container-title van-multi-ellipsis--l2"
            style="padding: 0;"
            :style="{ 'font-size': item.recommands || small ? '16px' : '18px' }"
          >
            {{ item.title }}
          </span>
          <div
            class="flex-center bottom"
            style="padding: 0;"
          >
            <div
              class="type"
              v-if="!item.recommands && item.type === 1"
            >
              图文
            </div>
            <div
              class="type"
              v-if="!item.recommands && item.type !== 1"
            >
              {{ item.type === 6 ? item.moments_pics_num && item.moments_pics_num == 1 ? '单图': '多图' : '长图' }}
            </div>
            <div class="flex-center">
              <img
                src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
                style="width:16px; height: 16px;margin-right: 2px;"
              />{{ item.readnum }}
            </div>
            <!-- <div class="flex-center" v-if="item.recommands">
              <img
                src="https://img.esenyun.com/images/20200325/cb636b484f964256958e1b2f47825cf5.png"
                style="width:16px; height: 16px;margin-right: 2px;"
              />{{ item.sharenum }}
            </div>
            <div class="flex-center" v-else>
              <img
                src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
                style="width:16px; height: 16px;margin-right: 2px;"
              />{{ item.readnum }}
            </div> -->
          </div>
        </div>
        <div class="right">
          <van-image
            width="90px"
            height="90px"
            fit="cover"
            radius="3"
            :src="item.pic"
          />
        </div>
      </div>
      <!-- 音频 -->
      <div
        class="more flex-center van-hairline--bottom"
        v-if="item.type == 7"
        @click="linkItem(item)"
      >
        <div class="left flex-center">
          <span
            decode
            class="container-title van-multi-ellipsis--l2"
            style="padding: 0;"
          >
            {{ item.title }}
          </span>
          <div
            class="flex-center bottom"
            style="padding: 0;"
          >
            <div class="flex-center">
              <div
                class="type"
                v-if="!item.recommands"
              >
                音频
              </div>
              <div
                class="flex-center"
                v-if="item.recommands"
              >
                <img
                  src="https://img.esenyun.com/images/20200709/33d1deef4cee4eb9be9dedd4d350d9d8.png"
                  style="width:16px; height: 16px;margin-right: 2px;"
                />{{ item.sharenum }}
              </div>
              <div
                class="flex-center "
                v-else
              >
                <img
                  src="https://img.esenyun.com/images/20200709/33d1deef4cee4eb9be9dedd4d350d9d8.png"
                  style="width:16px; height: 16px;margin-right: 2px;"
                />{{ item.readnum }}
              </div>
            </div>
            <div
              style="margin-left: 24rpx;flex: 1;"
              class="van-ellipsis"
            >
              内容由喜马拉雅APP提供
            </div>
          </div>
        </div>
        <div class="right">
          <van-image
            width="90px"
            height="90px"
            fit="cover"
            radius="3"
            :src="item.pic"
          />
          <img
            class="logo-tag"
            src="https://img.esenyun.com/images/20200709/96746c70297043729794802517e81f33.png"
            style=""
          />
        </div>
      </div>
      <!-- 视频-->
      <div
        class="video-scroll van-hairline--bottom"
        v-if="item.type === 3"
      >
        <span
          decode
          class="container-title van-multi-ellipsis--l2"
          @click="linkItem(item)"
        >
          {{ item.title }}
        </span>
        <!-- <ScrollVideo :index="0" :pic="item.pic" :materialId="item.id" />\ -->
        <!-- {{item.videoUrl}} -->
          <!-- :autoplay="true" -->
        <video
          :src="item.videoUrl"
          :poster="item.pic"
          width="100%" 
          height="210px"
          controls
        ></video>
        <div
          class="flex-center bottom"
          style="margin-top: 8px;"
        >
          <div class="type">视频</div>
          <div class="flex-center">
            <img
              src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
              style="width:16px; height: 16px;margin-right: 2px;"
            />{{ item.readnum }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    linkItem(item) {
      this.$emit("link", item);
    },
  },
};
</script>

<style lang="less" scoped>
.more {
  padding: 16px 0;
  .left {
    flex: 1;
    height: 90px;
    padding-right: 16px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
  }
  .right {
    width: 90px;
    position: relative;
    .logo-tag {
      position: absolute;
      left: 0;
      top: 0;
      width: 48px;
      height: 48px;
    }
  }
}
.bottom {
  font-size: 12px;
  line-height: 17px;
  padding-bottom: 16px;
  color: #969799;
}
.type {
  margin-right: 12px;
}
.container-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 8px;
  padding-top: 16px;
}
.long {
  .long-img {
    width: 100%;
  }
}
</style>
